module.exports = __webpack_public_path__ + "static/media/190-uzbekistn.fcb52145.svg";